import { render } from "./expertTravelSettings.vue?vue&type=template&id=547a1915&scoped=true&ts=true"
import script from "./expertTravelSettings.vue?vue&type=script&lang=ts"
export * from "./expertTravelSettings.vue?vue&type=script&lang=ts"

import "./expertTravelSettings.vue?vue&type=style&index=0&id=547a1915&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547a1915"]])

export default __exports__